import React, { useState } from 'react'
import FileBase from 'react-file-base64'
import { pushProducts } from '../api/index'
import './styles/PushProducts.css'

function PushProducts() {


    const [product, setProduct] = useState({
        name: '',
        desc: '',
        category: '',
        image: '',
        price: 0,
        specs: {}
    })

    const [err ,seterr] = useState('');

    const submitHandler = () => {

        if( product.name.trim() == "" || product.desc.trim() =="" || product.category.trim() =="" || product.image.trim() == "" || product.price == 0)
        {
            seterr(<h3 className = "error-text-push-products">Fields Missing ! Please check again.</h3>)
            return ;
        }
        seterr(<h3 className = "success-text-push-products">Product successfully uploaded</h3>)
        pushProducts(product);
    }

    let more_inputs = <></>
    if (product.category == "Laptop" || product.category == "PC") {
        more_inputs = (
            <>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, manufacturer: e.target.value } }) }}
                    placeholder="manufacturer"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, model: e.target.value } }) }}
                    placeholder="model"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, hdd: e.target.value } }) }}
                    placeholder="hdd"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, ram: e.target.value } }) }}
                    placeholder="ram"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, graphics: e.target.value } }) }}
                    placeholder="graphics"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, screen_size: e.target.value } }) }}
                    placeholder="screen_size"></input>
            </>
        )
    }
    else if (product.category == "Mobile") {
        more_inputs = (
            <>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, manufacturer: e.target.value } }) }}
                    placeholder="manufacturer"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, model: e.target.value } }) }}
                    placeholder="model"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, hdd: e.target.value } }) }}
                    placeholder="hdd"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, ram: e.target.value } }) }}
                    placeholder="ram"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, screen_size: e.target.value } }) }}
                    placeholder="screen_size"></input>
            </>
        )
    }
    else if (product.category == "Headphone" || product.category == "Earphone") {
        more_inputs = (
            <>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, driver_size: e.target.value } }) }}
                    placeholder="driver_size"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, output: e.target.value } }) }}
                    placeholder="output"></input>
                <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, manufacturer: e.target.value } }) }}
                    placeholder="manufacturer"></input>
                 <input
                    onChange={(e) => { setProduct({ ...product, specs: { ...product.specs, model: e.target.value } }) }}
                    placeholder="model"></input>
            </>
        )
    }

           
    let img_content = <></>;
    
    if( product.image.trim()!="")
       img_content =  <img src = {product.image}></img>;

    return (
        <div className="outer-push-products">
            {err}
            <input
                value={product.name}
                onChange={(e) => setProduct({ ...product, name: e.target.value })}
                placeholder="Product name"></input>

            <input
                value={product.desc}
                onChange={(e) => setProduct({ ...product, desc: e.target.value })}
                placeholder="Description"></input>

            <br></br>

            <select className = "select" value={product.category}>
                <option className="option"
                    onClick={(e) => { setProduct({ ...product, category: e.target.value }) }}
                    value="Laptop">Laptop</option>

                <option className="option" onClick={(e) => { setProduct({ ...product, category: e.target.value }) }}
                    value="Headphone">Headphone</option>

                <option className="option" onClick={(e) => { setProduct({ ...product, category: e.target.value }) }}
                    value="PC">PC</option>

                <option className="option" onClick={(e) => { setProduct({ ...product, category: e.target.value }) }}
                    value="Earphone">Earphone</option>

                <option className="option" onClick={(e) => { setProduct({ ...product, category: e.target.value }) }}
                    value="Mobile">Mobile</option>

            </select>


            {more_inputs}
            <br></br>
            <input
                type="number"
                value={product.price}
                onChange={(e) => setProduct({ ...product, price: e.target.value })}
                placeholder="Price"></input>

            <br></br>
            <FileBase
                type="file" multiple={false}
                value={product.image}
                onDone={({ base64 }) => { setProduct({ ...product, image: base64 }) }}>
            </FileBase>
            {img_content}
            <br></br>
            <button onClick={submitHandler}>SUBMIT</button>
        </div>
    )
}

export default PushProducts